import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .react-cookienotice-root {
    z-index: 9999;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    font-family: "Karla", sans-serif, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, 
    Fira Sans, Droid Sans, Helvetica Neue, sans-serif!important;
    font-size: 1.099rem;
    line-height: 1.75rem;
    overflow-x: hidden;
    position: relative;
  }
  a {
    color: inherit;
    text-decoration: none;
    transition-duration: .2s;
    -webkit-transition-duration: all 0.2s ease-in-out;
    -moz-transition-duration: all 0.2s ease-in-out;
    -o-transition-duration: all 0.2s ease-in-out;
    -ms-transition-duration: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  :root {
    --mgreen: #23A14B;
    --mgreenDark: #4F8460;
    --mgreenLight: #D3ECDB;
    --mgray: #23282D;
    --mg2: #9C9C9C;
    --mg3: #ccc;
    --mg4: #f7f7f7;
    --mwhite: #fafafa;
  }
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0px;
    padding: 0px;
  }
  main {
    width: 100%;
  }
  .b-shadow {
    box-shadow: 0px 0px 1px 2px rgb(0 0 0 / 6%)
  }
  .h-shadow {
    box-shadow: 0px 0px 1px 2px rgb(0 0 0 / 12%)
  }
  .metlab-header-img > div {
    box-shadow: 0px 2px 8px #0000008f;
  }
  #metlabHeader {
    z-index: 30;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
    transition: 0.2s;
    transition-timing-function: cubic-bezier(0.2, 0, 0.58, 1);
    margin-top:32px!important;
  }
  .sticky {
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 40;
    padding: 0.55rem 0;
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    transition: 0.3s;
    transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  .sticky + main {
    padding-top: 102px;
  }

  @media only screen and (max-width: 752px) {
    #metlabHeader {
      margin-top:0!important;
    }
  }



  /* ==========================================================================
    Marks, scrollbars
  ========================================================================== */
  ::selection {
    background: var(--mgreen);
    color: var(--mwhite);
    text-shadow: none;
  }
  ::-webkit-selection {
    background: var(--mgreen);
    color: var(--mwhite);
    text-shadow: none;
  }
  ::-moz-selection {
    background: var(--mgreen);
    color: var(--mwhite);
    text-shadow: none;
  }

  /* ==========================================================================
    Headings
  ========================================================================== */
  h1 {
    margin: 0 0 10px;
    font-size: 43px;
    line-height: 1.1;
    font-weight: 800;
    letter-spacing: -.0946rem!important;
  }
  h2 {
    margin: .5em 0;
    font-size: 36px!important;
    line-height: 130%;
    font-weight: 800!important;
    letter-spacing: -.0946rem!important;
  }
  h3 {
    margin-top: 1.5em;
    margin-bottom: .5em;
    font-size: 30px;
    line-height: 120%;
    font-weight: 800!important;
    letter-spacing: -.0946rem;
  }
  h4 {
    margin-top: 1.5em;
    margin-bottom: .5em;
    font-size: 22px;
    line-height: 140%;
    font-weight: 800!important;
    letter-spacing: -.0946rem!important;
  }
  h5 {
    margin-top: 1.5em;
    margin-bottom: .5em;
    font-size: 18px;
    line-height: 1.7em;
    font-weight: 800!important;
    letter-spacing: -.0946rem!important;
  }
  h6 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 120%;
    font-weight: 800!important;
    letter-spacing: -.0946rem!important;
  }
  @media screen and (max-width: 767px) {
    h1 {
        font-size: 40px;
    }
    h2 {
      font-size: 30px;
    }
    h3 {
      font-size: 25px;
    }
    .mainNav {
      padding:2px;
    }

  }


  /* Floaty floaty */
  body {
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }



  .card {
    position: relative;
    margin: 10px;
    transform: rotateX(0) rotateY(0);
    transform-style: preserve-3d;
    transition-duration: 0.1s;
    transition-timing-function: ease !important;
    backface-visibility: hidden;
    will-change: tranform;
    &__overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(http://alexandrebuffet.fr/codepen/parallax-cards/blur-overlay.jpg) no-repeat center center;
      background-size: cover;
      mix-blend-mode: lighten;
      opacity: 0.5;
    }
    &__image {
      img {
        max-width: 100%;
        height: auto;
        mix-blend-mode: lighten;
      }
    }
    &__heading {
      position: absolute;
      bottom: 20px; 
      left: 20px;
      width: 100%;
      color: #FFF;
      .small {
        display: inline-block;
        margin-bottom: 5px;
        text-transform: uppercase;
        font-size: 10px;
        transform: translateZ(15px);
      }
      h2 {
        margin: 0;
        transform: translateZ(30px);
      }
    }
    &.rounded {
      &, .card__overlay {
        border-radius: 8px;
      }
    }
    &.is-out {
      transform: rotateX(0) rotateY(0) !important;
      transition-duration: 1s;
    }
  }

  #superman {
  background-color: #3F51B5;
  }

  #batman {
  background-color: #424242;
  }

  #wonderwoman {
    background-color: #E91E63;
  }

  #aquaman {
    background-color: #00BCD4;
  }

  /* ==========================================================================
    COOKIE NOTICE
  ========================================================================== */

  ._1pNzT {
    background: #23a14b!important;
  }

  ._1GmO6 {
    background: #21b550!important;
  }

  ._LCP8o {
    color:white!important;
    border-color:white!important;
  }

  /* ==========================================================================
    SWIPER
  ========================================================================== */
  .swiper-wrapper img:hover {
    cursor: pointer;
  }
  .swiper-button-next, .swiper-button-prev {
    color: #fafafa!important;
  }
  .swiper-button-next:after, .swiper-button-prev:after {
    font-size: 1.6rem!important;
  }
  #Home_container__3sao- .swiper-pagination {
    position: absolute!important;

    @media (max-width: 1024px) { 
      display: none;
    }
  }
  .swiper-pagination {
    position: relative!important;
  }
  .swiper-pagination-progressbar {
    background: rgba(129, 105, 105, 0.15)!important;
  }
  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background-color: #a1ccae!important;
  }
  .swiper-pagination-bullet-active {
    background: #23a14b!important;
  }
  .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: 6px!important;
  }

  .pswp__caption__center {
    font-size: 1.5em!important;
  }


  /* PAGINATION */

  .pagination {
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pagination li a {
    display: inline-block;
    margin: 10px;
    background-color: #dfdfdf;
    border-radius: 2px;
    padding: 20px;
  }

  .pagination li.active a {
    background-color: green;
    color: white;
  }

  .pagination li.disabled a {
    background-color: #eee;
    color:gray;
  }


  /* ==========================================================================
    POST PAGES
  ========================================================================== */
  .postPage {
    max-width: 80rem;

    a {
        border-bottom: 2px solid #23A14B;
    }
    p {
      word-wrap: break-word;
      margin-bottom: 0.65rem;
    }
      
    blockquote {
        font-family: inherit;
        background-color:rgba(201, 8, 8, 0.35);
        word-wrap: break-word;
        box-decoration-break: clone;
        padding: 1.2999999999999998rem 2.3000000000000007rem 1.1rem 1.9rem;
        border-radius: .2rem;
        margin-bottom: 1rem;
    }
    ul {
      list-style-type: disc;

      li {
          margin-left: 2rem;
          margin-bottom: .5rem;
      }
    }
    h2 {
      font-size: 2.485rem!important;
      margin-top: 0.5rem;
      line-height: 120%;
      letter-spacing: -0.0946rem;
    }
    h5 {
      color: #9c9c9c;
      font-size: 1.3rem;
      margin-bottom: 0.5rem;
    }
    
    @media only screen and (min-width: 482px) {
      > * { 
        margin-left: 1.5rem;
        margin-right: 1.5rem;
      }
    }
  }


  .wp-block-columns {
    display: flex;
    margin-bottom: 1.75em;
    box-sizing: border-box;
    flex-wrap: wrap;
    align-items: center;

    &:not(.alignwide):not(.alignfull) {
      clear: both;
    }
    @media (min-width: 782px) {
        flex-wrap: nowrap;
    }
    @media (max-width: 990px) {
      flex-direction: column;
    }

    .wp-block-column {
      flex-basis: 0;
      flex-grow: 1;
      min-width: 0;
      word-break: break-word;
      overflow-wrap: break-word;
      margin-left: 1rem;
      margin-right: 1rem;

      &:last-child {
        margin-bottom: 0;
      }

      > *:first-child {
        margin-top: 0;
      }

      p {
        word-wrap: break-word;
      }
      h2 {
        font-size: 2.485rem!important;
        margin-top: 0.5rem;
        line-height: 120%;
        letter-spacing: -0.0946rem;
      }
      h5 {
        color: #9c9c9c;
        font-size: 1.3rem;
        margin-bottom: 0.5rem;
      }

      @media (min-width: 782px) {
        &:not(:first-child) {
          margin-left: 2em;
        }
      }

      @media only screen and (min-width: 482px) {
        > * { 
          margin-top: 1rem;
          margin-bottom: 1rem;
        }
      }
      
    }
  }

  .editor-styles-wrapper .wp-block {
    margin-left: auto;
    margin-right: auto;
  }
  .wp-block-gallery.has-nested-images {
    display: flex;
    flex-wrap: wrap;
  }
  .block-editor-block-list__layout .block-editor-block-list__block {
    position: relative;
    overflow-wrap: break-word;
  }
  figure.wp-block-gallery {
    display: block;
    margin: 0;
  }
  .blocks-gallery-grid, .wp-block-gallery {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  html :where(.wp-block) {
    max-width: 840px;
    margin-top: 28px;
    margin-bottom: 28px;
  }
  .wp-block figure {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;
  }

  .wp-block-gallery.has-nested-images figure.wp-block-image {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    position: relative;
    margin-top: auto;
    margin-bottom: auto;
    flex-direction: column;
  }
  .blocks-gallery-grid:not([data-align])>.wp-block-image {
    display: grid;
    grid-template-columns: [image] minmax(0,max-content) [placeholder] auto;
  }
  .editor-styles-wrapper .wp-block {
    margin-left: auto;
    margin-right: auto;
  }
  .block-editor-block-list__layout .block-editor-block-list__block {
    position: relative;
    overflow-wrap: break-word;
  }
  .wp-block-gallery.has-nested-images.is-cropped figure.wp-block-image:not(#individual-image) a, .wp-block-gallery.has-nested-images.is-cropped figure.wp-block-image:not(#individual-image) img {
    width: 100%;
    flex: 1 0 0%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;

    &:hover {
      cursor: pointer;
    }
  }
  .wp-block-image img {
    height: auto;
    max-width: 100%;
    vertical-align: bottom;
  }
  .wp-block-gallery.has-nested-images figure.wp-block-image img {
    display: block;
    height: auto;
    max-width: 100%;
    width: auto;
  }
  .wp-block-image:not(.is-style-rounded)>a, .wp-block-image:not(.is-style-rounded) img {
    border-radius: inherit;
  }
  .wp-block-gallery.has-nested-images figure.wp-block-image figcaption {
    white-space: pre-wrap;
    min-width: 1px;
    background: linear-gradient(0deg,rgba(0,0,0,.7),rgba(0,0,0,.3) 70%,transparent);
    bottom: 0;
    color: #fafafa;
    font-size: 13px;
    left: 0;
    margin-bottom: 0;
    max-height: 60%;
    overflow: auto;
    padding: 0 8px 8px;
    position: absolute;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .wp-block-image:not(.wp-block-gallery.has-nested-images) img {
    margin: 0 auto;
  }
  .wp-block-gallery.has-nested-images.is-cropped figure.wp-block-image:not(#individual-image)>a, .wp-block-gallery.has-nested-images.is-cropped figure.wp-block-image:not(#individual-image)>div:not(.components-drop-zone) {
    display: flex;
  }
  .wp-block-gallery.has-nested-images figure.wp-block-image>a, .wp-block-gallery.has-nested-images figure.wp-block-image>div {
    margin: 0;
    flex-direction: column;
    flex-grow: 1;
  }
  :not([data-align])>.wp-block-image>div:not(.components-placeholder) {
    grid-column: image;
  }
  .wp-block-image:not(.is-style-rounded)>div:not(.components-placeholder) {
    border-radius: inherit;
  }
  .wp-block-gallery.has-nested-images figcaption {
    flex-grow: 1;
    flex-basis: 100%;
    text-align: center;
  }
  .wp-block-image figcaption {
    color: #555;
    font-size: 13px;
    text-align: center;
  }
  .wp-block-image figcaption {
    margin-top: 0.5em;
    margin-bottom: 1em;
  }
  .blocks-gallery-grid figcaption, .wp-block-gallery figcaption {
    flex-grow: 1;
  }

  .wp-block-gallery.has-nested-images.columns-default figure.wp-block-image:not(#individual-image) {
    align-self: inherit;
    margin: 0 16px 16px 0;
    width: 50%;

    @media (min-width: 600px) {
      margin-right: 16px;
      width: 32%;
    }
  }
`;

export const MainInner = styled.div`
  position: relative;
  width: 100vw;
  height: 100%;
  max-width: 1440px;
  padding: 0 70px;
  margin: 0 auto;

  @media screen and (max-width: 680px) {
    max-width: 100%;
    padding: 0px 16px;
  }
`;

export default GlobalStyle;
